import axios from "axios";

export const getLicenses = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/License/licenses`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
